








































































import { defineComponent, ref, watch } from '@vue/composition-api'
import { useStore } from '@/store'

export default defineComponent({
  name: 'Havenhuis2',

  props: {
    next: String
  },

  setup() {
    const { state } = useStore()

    const step = ref(1)

    watch(step, () => {
      const content = document.querySelector('.c-popover--open')
      if (content) {
        content.scrollTop = 0
      }
    })

    return {
      state,
      step
    }
  }
})
